import { AppApiURL } from '@app/app.settings';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class TechService {
  constructor(private http: HttpClient) {}

  confirmPhoneNumber(number: string): Observable<unknown> {
    const encoded = encodeURIComponent(String(number).trim());
    return this.http.post<unknown>(AppApiURL + '/tech/confirmPhoneNumber/' + encoded, null, {
      withCredentials: true,
      observe: 'body'
    });
  }
}
